/**
 * sob-facets.js v2 — Client-side tag filter for Sons of Beaches collection pages.
 *
 * v2 adds AJAX page-prefetch: on load, silently fetches remaining paginated
 * pages and merges cards into the grid so filtering always operates on the
 * full collection, not just page 1. Pagination controls hidden after merge.
 *
 * Filter logic: AND across groups, OR within each group.
 * URL params:   ?series=sportfish,boat_badges&pt=tees&fit=vintage&color=blues
 *
 * Zero dependencies. Safe to load deferred.
 */

(function () {
  'use strict';

  var GROUPS = ['series', 'pt', 'fit', 'color'];
  var MAX_PAGES = 20;               // safety cap
  var CARD_SEL = '.sob-filter-item[data-tags]';

  // ── helpers ────────────────────────────────────────────────────────────────

  function getCards() {
    return Array.from(document.querySelectorAll(CARD_SEL));
  }

  function getChecked() {
    var state = {};
    GROUPS.forEach(function (g) { state[g] = []; });
    document.querySelectorAll('.sob-facet-cb:checked').forEach(function (cb) {
      var group = cb.dataset.group;
      var tag   = cb.dataset.tag;
      if (state[group]) state[group].push(tag);
    });
    return state;
  }

  // ── filter ─────────────────────────────────────────────────────────────────

  function applyFilter() {
    var checked = getChecked();
    var cards   = getCards();
    var showing = 0;

    cards.forEach(function (card) {
      var cardTags = (card.dataset.tags || '').split(/\s+/).filter(Boolean);
      var visible  = true;

      for (var gi = 0; gi < GROUPS.length; gi++) {
        var group    = GROUPS[gi];
        var selected = checked[group];
        if (!selected.length) continue;

        var match = false;
        for (var si = 0; si < selected.length; si++) {
          if (cardTags.indexOf(selected[si]) !== -1) { match = true; break; }
        }
        if (!match) { visible = false; break; }
      }

      card.style.display = visible ? 'contents' : 'none';
      if (visible) showing++;
    });

    updateCounter(showing, cards.length, checked);
    updateUrl(checked);
  }

  function updateCounter(showing, total, checked) {
    var counter = document.getElementById('SobFacetCounter');
    if (!counter) return;
    var hasFilter = GROUPS.some(function (g) { return checked[g].length > 0; });
    counter.style.display = hasFilter ? 'block' : 'none';
    var showEl = document.getElementById('SobShowing');
    var totEl  = document.getElementById('SobTotal');
    if (showEl) showEl.textContent = showing;
    if (totEl)  totEl.textContent  = total;
  }

  function updateUrl(checked) {
    try {
      var url = new URL(window.location.href);
      var tagToParam = {};
      document.querySelectorAll('.sob-facet-cb').forEach(function (cb) {
        tagToParam[cb.dataset.tag] = cb.dataset.param;
      });
      GROUPS.forEach(function (group) {
        var vals = checked[group];
        if (!vals.length) {
          url.searchParams.delete(group);
        } else {
          var params = vals.map(function (t) {
            return tagToParam[t] || t.replace(/^[^_]+_/, '');
          });
          url.searchParams.set(group, params.join(','));
        }
      });
      history.replaceState(null, '', url.toString());
    } catch (e) {}
  }

  function updateCounts() {
    var cards    = getCards();
    var tagCount = {};
    cards.forEach(function (card) {
      (card.dataset.tags || '').split(/\s+/).filter(Boolean).forEach(function (t) {
        tagCount[t] = (tagCount[t] || 0) + 1;
      });
    });
    document.querySelectorAll('.sob-count[data-tag]').forEach(function (el) {
      var n = tagCount[el.dataset.tag] || 0;
      el.textContent = '(' + n + ')';
    });
  }

  function restoreFromUrl() {
    try {
      var url = new URL(window.location.href);
      GROUPS.forEach(function (group) {
        var param = url.searchParams.get(group);
        if (!param) return;
        var paramVals = param.split(',').filter(Boolean);
        document.querySelectorAll('.sob-facet-cb[data-group="' + group + '"]').forEach(function (cb) {
          if (paramVals.indexOf(cb.dataset.param) !== -1) cb.checked = true;
        });
      });
    } catch (e) {}
  }

  // ── AJAX prefetch of remaining pages ───────────────────────────────────────

  /** Determine total page count from the pagination widget on this page. */
  function detectTotalPages() {
    var pag = document.querySelector('.pagination, nav.pagination, [aria-label*="agination"]');
    if (!pag) return 1;
    // Look for page-number links; find the max integer among them
    var max = 1;
    pag.querySelectorAll('a, span, li').forEach(function (el) {
      var t = (el.textContent || '').trim();
      var n = parseInt(t, 10);
      if (!isNaN(n) && n > max) max = n;
      var href = el.getAttribute && el.getAttribute('href');
      if (href) {
        var m = href.match(/[?&]page=(\d+)/);
        if (m) {
          var pn = parseInt(m[1], 10);
          if (pn > max) max = pn;
        }
      }
    });
    return max;
  }

  function findGridContainer() {
    var cards = getCards();
    if (!cards.length) return null;
    return cards[0].parentNode; // <motion-list> or similar
  }

  function showPrefetchIndicator(remainingPages) {
    var counter = document.getElementById('SobFacetCounter');
    if (!counter) return null;
    var ind = document.createElement('div');
    ind.id = 'SobPrefetchIndicator';
    ind.style.cssText = 'font-size:0.85em;opacity:0.7;margin-top:4px;';
    ind.textContent = 'Loading full collection (' + remainingPages + ' more page' + (remainingPages > 1 ? 's' : '') + ')…';
    counter.parentNode.insertBefore(ind, counter.nextSibling);
    return ind;
  }

  function hidePagination() {
    document.querySelectorAll('.pagination, nav.pagination, [aria-label*="agination"]').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  /** Fetch page N of this collection URL, return an array of card nodes to append. */
  function fetchPage(pageNum) {
    var base = window.location.pathname;
    var url  = base + '?page=' + pageNum;
    return fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'sob-facets' } })
      .then(function (r) {
        if (!r.ok) throw new Error('page ' + pageNum + ' HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.from(doc.querySelectorAll(CARD_SEL));
      });
  }

  /** Fetch pages 2..N in order, merge into grid, then re-init counts + filter. */
  function prefetchRemainingPages() {
    var totalPages = Math.min(detectTotalPages(), MAX_PAGES);
    if (totalPages <= 1) return Promise.resolve();

    var grid = findGridContainer();
    if (!grid) return Promise.resolve();

    var indicator = showPrefetchIndicator(totalPages - 1);
    var chain = Promise.resolve();
    for (var p = 2; p <= totalPages; p++) {
      (function (pageNum) {
        chain = chain.then(function () {
          return fetchPage(pageNum).then(function (cards) {
            cards.forEach(function (c) {
              // Import into current document + append
              var imported = document.importNode(c, true);
              grid.appendChild(imported);
            });
          }).catch(function (err) {
            console.warn('[sob-facets] page fetch failed:', err);
          });
        });
      })(p);
    }
    return chain.then(function () {
      if (indicator) indicator.remove();
      hidePagination();
      updateCounts();
      applyFilter();
    });
  }

  // ── init ───────────────────────────────────────────────────────────────────

  function init() {
    updateCounts();
    restoreFromUrl();
    applyFilter();

    document.querySelectorAll('.sob-facet-cb').forEach(function (cb) {
      cb.addEventListener('change', applyFilter);
    });

    // Kick off background prefetch of remaining pages (non-blocking)
    prefetchRemainingPages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
